import React from "react";
import CaseStudyHeading from "../CaseStudiesHeading";
import CaseStudyProfile from "../CaseStudiesProfile";

// Sections
import OrgAgent from "./OrgAgent";
import Muiplay from "./Muiplay";
import Redactd from "./Redactd";

const AI = () => {
  return (
    <React.Fragment>
      <CaseStudyHeading title="AI / Tooling" />
      <CaseStudyProfile>
        <p>
          I explore AI as practical tooling for product teams, especially where design systems and front-end delivery
          meet. My focus is on tools that reduce setup time, generate usable structure, and keep teams aligned to real
          components, standards, and user outcomes.
        </p>
        <p>
          This section covers the tools and patterns I am building to support discovery, prototyping, and implementation
          in real workflows, including prompt-to-layout generation, role-aware agents, and system-guided decision
          making.
        </p>
      </CaseStudyProfile>
      {Redactd}
      {OrgAgent}
      {Muiplay}
    </React.Fragment>
  );
};

export default AI;
